// extracted by mini-css-extract-plugin
export var closeButton = "_qc-2";
export var closeButtonIcon = "_qc-3";
export var lightboxContent = "_qc-1";
export var lightboxOverlay = "_qc-0";